// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"014c41c6","521":"3d063457"}[chunkId] + ".chunk.js";
};